export type ProductGroup = {
  id: number;
  uri: string;
  description: string;
  name: string;
  sortIndex: number;
  categories: { uri: string };
  accessType: string;
  metadata: {
    uri: string;
    entries?: Record<string, { lang: string; value: string }[]>;
    empty: boolean;
  };
  productsUri: { products: Product[] };
  productGroupAccesses: { uri: string };
  saleStatus: string;
  checkAccessForProgramRelations: boolean;
};

export type Product = {
  id: number;
  uri: string;
  paymentPlan: {
    id: number;
    name: string;
    period: number;
    periodIso: string;
    paymentType: string;
  };
  enabled: boolean;
  minimumPeriods: number;
  price: number;
  productGroupId: number;
  productPayments: {
    productPaymentList: ProductPayment[];
  };
  currency: string;
  productStatus: string;
  description?: string;
  discountedInitPrice?: number;
};

export type GetAllProductGroupsResponse = {
  productGroups: ProductGroup[];
};

export const isValidGetAllProductGroupsResponse = (
  json: unknown,
): json is GetAllProductGroupsResponse => {
  if (
    typeof json === 'object' &&
    json !== null &&
    'productGroups' in json &&
    json.productGroups
  ) {
    return Array.isArray(json.productGroups);
  }
  return false;
};

export const isValidProductGroupResponse = (
  json: unknown,
): json is ProductGroup => {
  if (
    typeof json !== 'object' ||
    json === null ||
    !('id' in json) ||
    !('uri' in json) ||
    !('name' in json) ||
    !('productsUri' in json)
  ) {
    return false;
  }

  const candidate = json as Record<string, unknown>;
  const productsUri = candidate.productsUri;

  return (
    typeof productsUri === 'object' &&
    productsUri !== null &&
    'products' in productsUri &&
    Array.isArray((productsUri as Record<string, unknown>).products)
  );
};

export type ProductPaymentResponse = {
  productPaymentList: ProductPayment | ProductPayment[];
};

export type ProductPayment = {
  id: number;
};

export const isValidProductPaymentResponse = (
  json: unknown,
): json is ProductPaymentResponse => {
  if (
    typeof json === 'object' &&
    json !== null &&
    'productPaymentList' in json &&
    json.productPaymentList
  ) {
    return (
      Array.isArray(json.productPaymentList) || json.productPaymentList !== null
    );
  }
  return false;
};

export type TvodProduct = {
  productId: number;
  productGroupId: number;
  stripeProductId: string;
  vimondProductPaymentIds: number[];
  price: number;
  currency: string;
  period: string;
  name: string;
  intervalCount: string | null;
  intervalUnit: string | null;
  rentalDurationHours: number | null;
};
